import script from "./PersonalInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonalInfo.vue?vue&type=script&setup=true&lang=ts"

import "./PersonalInfo.vue?vue&type=style&index=0&id=ce159f40&scoped=true&lang=scss"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce159f40"]])

export default __exports__